import { render, staticRenderFns } from "./ModalRegistration.vue?vue&type=template&id=5f4d846e"
import script from "./ModalRegistration.vue?vue&type=script&lang=js"
export * from "./ModalRegistration.vue?vue&type=script&lang=js"
import style0 from "./ModalRegistration.vue?vue&type=style&index=0&id=5f4d846e&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports